import { Card, Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";

export default function FinalReportObservationsCardSkeleton() {
    return (
        <Card sx={{ padding: 2 }} variant="outlined">
            <Skeleton variant="text" width={120} height={32} />
            <Table sx={{ tableLayout: "fixed" }}>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Skeleton variant="text" width={60} />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={60} />
                        </TableCell>
                        <TableCell>
                            <Skeleton variant="text" width={80} />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[1, 2, 3].map(i => (
                        <TableRow key={i}>
                            <TableCell>
                                <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="text" />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Card>
    );
}
